import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-about-us',
  imports: [CommonModule],
  templateUrl: './about-us.html',
  styleUrl: './about-us.css',
})
export class AboutUs {
  readonly feature = {
    title: 'We Build Companies, Not Just Portfolios',
    image: '/light-mode-logo.webp',
  };

  readonly highlights = [
    {
      icon: 'innovation',
      title: 'Industry Agnostic',
      description:
        'From the field to the factory to the cloud—if the potential is there, we build it.',
    },
    {
      icon: 'precision',
      title: 'Equity-Based Partnership',
      description:
        'We operate as co-owners, ensuring our interests are perfectly aligned with your long-term success.',
    },
    {
      icon: 'integrity',
      title: 'Operational Powerhouse',
      description:
        'We provide the administrative, technical, and strategic frameworks so you can focus on your core industry innovation.',
    },
  ];
}
